<template>
    <table class="text-center font-weight-bold">
        <tr :class="[{'grey lighten-3': !input}]">
            <td :class="[{'reportBorders': !input}]">Schnitt</td>
            <td :class="[{'reportBorders': !input}]">FW</td>
            <td :class="[{'reportBorders': !input}]">Abräumen</td>
            <td :class="[{'reportBorders': !input}]">Gesamtkegel</td>
            <td colspan="3" :class="[{'reportBorders': !input}]">Endergebnis</td>
            <td :class="[{'reportBorders': !input}]">Gesamtkegel</td>
            <td :class="[{'reportBorders': !input}]">Abräumen</td>
            <td :class="[{'reportBorders': !input}]">FW</td>
            <td :class="[{'reportBorders borderRight': !input}]">Schnitt</td>
        </tr>
        <tr :class="[{'white': !input}, {'greyCell': input}]" >
        <!-- Schnitt -->
            <td :class="dataObject.getCSSColorCup('heim', ['leftCell'])">
                {{dataObject.heim.result.schnitt}}</td>
        <!-- Fehlwürfe -->
            <td :class="dataObject.getCSSColorCup('heim', ['leftCell'])">
                {{dataObject.heim.result.fw}}
            </td>
        <!-- Abräumen -->
            <td :class="dataObject.getCSSColorCup('heim', ['leftCell'])">
                {{dataObject.heim.result.ar}}</td>
        <!-- Kegel -->
            <td :class="dataObject.getCSSColorCup('heim', ['leftCell bigFont'])">
                {{dataObject.heim.result.kegel}}
                <div class="caption blue--text">{{dataObject.getTeamRekordString('heim')}}</div>
            </td>
        <!-- GESAMTERGEBNIS -->
            <td class="leftCell bigFont">{{dataObject.getKegelDeltaSign('heim')}}</td>
            <td class="leftCell bigFont">{{dataObject.getKegelDelta()}}</td>
            <td class="leftCell bigFont">{{dataObject.getKegelDeltaSign('gast')}}</td>
        <!-- Kegel -->
            <td :class="dataObject.getCSSColorCup('gast', ['leftCell bigFont'])">
                {{dataObject.gast.result.kegel}}
                <div class="caption blue--text">{{dataObject.getTeamRekordString('gast')}}</div>
            </td>
        <!-- Abräumen -->
            <td :class="dataObject.getCSSColorCup('gast', ['leftCell'])">
                    {{dataObject.gast.result.ar}}</td>
        <!-- Fehlwürfe -->
            <td :class="dataObject.getCSSColorCup('gast', ['leftCell'])">
                {{dataObject.gast.result.fw}}
            </td>
        <!-- Schnitt -->
            <td :class="dataObject.getCSSColorCup('gast', ['leftCell borderRight'])">
                {{dataObject.gast.result.schnitt}}</td>
        </tr>
    </table>
</template>

<script>
    export default {
        name: "spiel-bericht-edit-result-cup",
        props: ['dataObject', 'input'],
    }
</script>

<style scoped>
    table {width: 100%; border-spacing: 0; table-layout: auto;}
    .greyCell { background-color: #eee }
    .bigFont {font-size: 18px}
    .leftCell {
        border-left: solid 1px grey;
        border-top: solid 1px grey;
        border-bottom: solid 1px grey;
        padding-top: 8px;
        padding-bottom: 8px;
    }
    .reportBorders {
        border-left: solid 1px grey;
        border-top: solid 1px grey;
    }
    .borderRight {border-right: solid 1px grey; }
</style>